// Translation strings for Sidebar Navigation
// Supports Arabic (ar) and English (en)

export const translations = {
  en: {
    // Primary navigation items
    myVehicleCollection: 'My Vehicle Collection',
    ffAiHypercarPlus: 'FF aiHypercar+',
    service: 'Service',
    events: 'Events',
    futuristCoCreationPoints: 'Futurist Co-creation Points',
    referralProgram: 'Referral Program',
    fxCredits: 'FX Credits',
    fxReferralProgram: 'FX Referral Program',
    userResources: 'User Resources',
    accountInfo: 'Account Info',
    
    // Secondary navigation items
    signOut: 'Sign Out',
  },
  
  ar: {
    // Primary navigation items
    myVehicleCollection: 'مجموعة مركبتي',
    ffAiHypercarPlus: 'FF aiHypercar+',
    service: 'الخدمات',
    events: 'الفعاليات',
    futuristCoCreationPoints: 'نقاط الخلق المشترك المستقبلي',
    referralProgram: 'برنامج الإحالة',
    fxCredits: 'أرصدة FX',
    fxReferralProgram: 'برنامج إحالة FX',
    userResources: 'موارد المستخدم',
    accountInfo: 'معلومات الحساب',
    
    // Secondary navigation items
    signOut: 'تسجيل الخروج',
  }
} as const;

// Type exports for TypeScript support
export type Language = 'en' | 'ar';
export type TranslationKey = keyof typeof translations.en;

